export class BmarkSummaryAlertStatus {
  public hco_alert: boolean = false;
  public hco_ids: Set<string> = null;
  public hco_orders: number = 0;
  public sco_alert: boolean = false;
  public sco_ids: Set<string> = null;
  public sco_orders: number = 0;

  constructor() {}
}
